module.exports = require('@untool/core').internal.getConfig();
